import { isValidElement, ReactElement, ReactNode } from 'react'

import { Item, ItemProps } from './components/item'
import {
  BodySharedBlock,
  BodySharedBlockProps,
  HeaderSharedBlock,
  HeaderSharedBlockProps,
} from './components/shared'

export const isItem = (child: ReactNode): child is ReactElement<ItemProps> => {
  return isValidElement<ItemProps>(child) && child.type === Item
}
export const isHeaderSharedBlock = (
  child: ReactNode
): child is ReactElement<HeaderSharedBlockProps> => {
  return isValidElement<HeaderSharedBlockProps>(child) && child.type === HeaderSharedBlock
}

export const isBodySharedBlock = (
  child: ReactNode
): child is ReactElement<BodySharedBlockProps> => {
  return isValidElement<BodySharedBlockProps>(child) && child.type === BodySharedBlock
}
